import { gql } from 'graphql-request'

export const GET_TOTAL_NOTIFICATION_COMMENT = gql`
  query GetTotalNotificationComment {
    getTotalNotificationComment {
      totalComment
    }
  }
`
